if ($.browser.msie) {
    var mobileHeaderHeight = 113;
    var desktopHeaderHeight = 145;
    var header = $('header');

    $("<style>")
        .prop("type", "text/css")
        .html("\
            #header-spacer-ie {\
                height: " + mobileHeaderHeight + "px;\
            }\
            @media (min-width: 700px) {\
                #header-spacer-ie {\
                    height: " + desktopHeaderHeight + "px;\
                }\
            }")
        .appendTo("head");
    header.addClass("fixed-top").removeClass("sticky-top");
    var headerSpacer = $("<div id='header-spacer-ie'></div>");
    headerSpacer.insertAfter(header);

    $(document).ready(function () {
        var observer = new MutationObserver(resizeHeader);
        observer.observe(header[0], {attributes: true, subtree: true});

        function resizeHeader() {
            var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

            var transitionVal = "0.5s";
            var headerSpacerHeight = header.outerHeight();
            if (scrollTop > desktopHeaderHeight) {
                transitionVal = "0s";
                headerSpacerHeight = desktopHeaderHeight
            }

            var styles = {
                height: headerSpacerHeight,
                transition: transitionVal
            };
            headerSpacer.css(styles);
        }
    });
}
